import { get, post, del, put } from '@api/request';

export async function fetchExemptionTaxLimitations(
  { assessmentService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/taxlimitations`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createExemptionTaxLimitation(
  { assessmentService },
  authenticationToken,
  { pExemptionID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/taxlimitations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateExemptionTaxLimitation(
  { assessmentService },
  authenticationToken,
  { pTaxLimitationID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitlimitation/${pTaxLimitationID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteExemptionTaxLimitation(
  { assessmentService },
  authenticationToken,
  { pTaxLimitationID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitlimitation/${pTaxLimitationID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchExemptionTaxingUnits(
  { assessmentService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createExemptionTaxingUnit(
  { assessmentService },
  authenticationToken,
  { pExemptionID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/taxingunits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateExemptionTaxingUnit(
  { assessmentService },
  authenticationToken,
  { pExemptionTaxingUnitID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunit/${pExemptionTaxingUnitID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteExemptionTaxingUnit(
  { assessmentService },
  authenticationToken,
  { pExemptionTaxingUnitID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunit/${pExemptionTaxingUnitID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchExemptionApplication(
  { assessmentService },
  authenticationToken,
  { pExemptionID },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/application`;
  const { body } = await get(authenticationToken, url);
  return body;
}

// exemption applications
export async function fetchExemptionApplications(
  { assessmentService },
  authenticationToken,
  { propertyId },
) {
  const url = `${assessmentService}/assessment/property/${propertyId}/applications`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateExemptionApplication(
  { assessmentService },
  authenticationToken,
  { pExemptionID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemption/${pExemptionID}/application`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchMultiExemptionSegments(
  { assessmentService },
  authenticationToken,
  { pid, pYear, pVersion, pRollCorr, pageNum, pageSize },
) {
  const url = `${assessmentService}/assessment/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/exemptiontaxingunitsegments?pageSize=${pageSize}&page=${pageNum}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchExemptionSegments(
  { assessmentService },
  authenticationToken,
  { pExemptionTaxingUnitID, pageNum, pageSize },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunit/${pExemptionTaxingUnitID}/segments?pageSize=${pageSize}&page=${pageNum}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function associateExemptionSegment(
  { assessmentService },
  authenticationToken,
  { pExemptionTaxingUnitID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunit/${pExemptionTaxingUnitID}/segments`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateExemptionSegment(
  { assessmentService },
  authenticationToken,
  { pExemptionTaxingUnitSegmentID, payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitsegments/${pExemptionTaxingUnitSegmentID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massAssociateExemptionSegment(
  { assessmentService },
  authenticationToken,
  { payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitsegments/masscreate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function massDeleteExemptionSegment(
  { assessmentService },
  authenticationToken,
  { payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitsegments/massdelete`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function massDeleteExemptionBySegment(
  { assessmentService },
  authenticationToken,
  { payload },
) {
  const url = `${assessmentService}/assessment/propertyaccountexemptiontaxingunitsegments/massdeletebysegment`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchTaxingUnitValueTypes(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/exemption/taxingunitvaluetype`;
  const { body } = await get(authenticationToken, url);
  return body;
}